import { authHeader, handleResponse } from "../helpers";

export const liveSalesService = {
  list,
};

function list(params) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = new URL(`${process.env.REACT_APP_API_URL}api/v1/liveSales/list`);
  url.search = new URLSearchParams({
    type: params.type || "all",
    offset: params.offset ?? 0,
    limit: params.limit ?? 10,
  });
  return fetch(url, requestOptions).then(handleResponse);
}
